import React from 'react';
import { connect } from 'react-redux';
import { ReactComponent as BenchmarkFlag } from '../../static/assets/benchmark-flag-long.svg';
import { ReactComponent as HomeIcon } from '../../static/assets/home.svg';
import { ReactComponent as ConfigIcon } from '../../static/assets/config.svg';
import Next from '../../static/images/btn-next.png';
import Prev from '../../static/images/btn-prev.png';
import { manipulateLiValue, checkIfActiveDataSet } from '../../utils/dataSet/actions';
import { resetAll } from '../../utils/filter/actions';
import {IS_DEVELOPMENT, PREFIX_URL} from "../../constants";
import {ReactComponent as BenchmarkFlagOrange} from "../../static/assets/benchmark-flag-long-orange.svg";
import {SliderFlags} from "../../components/Sliders/sliderFlags";

class LeadIndicators extends React.Component {
  state = {
    isMounted: true,
    showInfoBox: null,
    'filter-history-popover': false,
  }

  componentDidMount() {
    this.props.checkIfActiveDataSet();
  }

  handleItemClick = (event) => {
    const name = event.currentTarget.getAttribute('name');
    let newPath;
    if (name === 'start') {
      newPath = PREFIX_URL;
    } else {
      newPath = `${PREFIX_URL}${name}`;
    }
    if (this.props.history.location.pathname !== newPath) {
      this.setState({ isMounted: false });
      this.awaitBeforeHistoryPush(newPath, 2000, this.props.history.push);
    }
  }

  handleInfoClick = (event) => {
    const id = event.currentTarget.getAttribute('id');
    if (this.state.showInfoBox === id) {
      this.setState({ showInfoBox: null });
    } else {
      this.setState({ showInfoBox: id });
    }
    if (id === 'filter-history-popover' && this.state['filter-history-popover']) {
      this.setState({ 'filter-history-popover': false });
    } else if (id === 'filter-history-popover') {
      this.setState({ 'filter-history-popover': true });
    }
  }

  handleResetClick = (event) => {
    event.stopPropagation();
    this.setState({ isMounted: false, 'filter-history-popover': false });
    this.awaitBeforeCallback(2000, this.props.resetAll);
  }

  awaitBeforeCallback(time, callback) {
    setTimeout(function() {
      callback();
    }, time)
  }

  awaitBeforeHistoryPush(newPath, time, callback) {
    setTimeout(function() {
      callback(newPath);
    }, time)
  }

  rangeChange = (e) => {
    const id = e.currentTarget.getAttribute('id');
    const min = e.currentTarget.getAttribute('min');
    const max = e.currentTarget.getAttribute('max');
    const { valueAsNumber, name } = e.target;
    this.setState({[name]: valueAsNumber, ['min-'+name]: min, ['max-'+name]: max});
    this.props.manipulateLiValue(id, valueAsNumber);
  }

  getPopoverOffset(newPoint) {
    switch(true){
      case (newPoint < .11359):
        return '-9.34%';
      case (newPoint > .1136 && newPoint <= .1931):
        return '-9.73%';
      case (newPoint > .1931 && newPoint <= .231):
        return '-9.993%';
      case (newPoint > .231 && newPoint <= .2851):
        return '-10.093%';
      case (newPoint > .2851 && newPoint <= .339):
        return '-9.993%';
      case (newPoint > .339 && newPoint <= .3915):
        return '-10.293%';
      case (newPoint > .3915 && newPoint <= .4492):
        return '-10.553%';
      case (newPoint > .4492 && newPoint < .5):
        return '-10.793%';
      case (newPoint > .51 && newPoint <= .62):
        return '-11.093%';
      case (newPoint > .62 && newPoint <= .75):
        return '-11.493%';
      case (newPoint > .75 && newPoint <= .89):
        return '-11.893%';
      case (newPoint > .89):
        return '-12.365%';
      default:
        return '-10.77%';
    }
  }

  getBenchmarkOffset(newPoint) {
    switch(true){
      case (newPoint < .11359):
        return '0';
      case (newPoint > .89):
        return '-1.765%';
      default:
        return '0';
    }
  }

  renderRanges() {
    if (IS_DEVELOPMENT) console.log(this.props?.leadRanges);
    return (
      this.props.leadRanges.map((range, index) => (
        <div className="row range-data" key={index}>
          {/*left column */}
          <div className="col-3 first-col">
            <div>
              {
                range['label']} {range['unit_prefix']} {range['info_text'] &&
                  <i id={range['id']} className="fas fa-info-circle" onClick={this.handleInfoClick} />
              }
              {
                range['info_text'] &&
                  <div
                      className="info-popover"
                      style={this.state.showInfoBox === range['id'] ? {opacity: 1} : {opacity: 0, display: 'none'}}
                  >
                  <h3>{range['label']} {range['unit_prefix']}</h3>
                  {range['info_text']}
                </div>
              }
            </div>
          </div>
          {/*range column */}
          <div className="col range">
            <div className="custom-range-outer">
              <div
                className="range-popover"
                key={this.state[`lead-${range['label']}`]}
                style={
                  this.state[`lead-${range['label']}`] !== undefined
                      ? {
                          left: (
                              (this.state[`lead-${range['label']}`] - this.state[`min-lead-${range['label']}`]) / //120
                              (this.state[`max-lead-${range['label']}`] - this.state[`min-lead-${range['label']}`])  //300
                              * 100) + '%',
                          marginLeft: this.getPopoverOffset(this.state[`lead-${range['label']}`] / range['max_value'])
                        }
                      : {
                          left: (
                              (range['value'] - range['min_value']) /
                              (range['max_value'] - range['min_value'])
                              * 100) + '%',
                          marginLeft: this.getPopoverOffset(range['value'] / range['max_value'])
                        }
                }
              >
                <span>
                  {
                    this.state[`lead-${range['label']}`] !== undefined
                        ? this.state[`lead-${range['label']}`]
                        : range['as_is'] }&nbsp;{range['unit_prefix']
                  }
                </span
                >
              </div>

                <SliderFlags
                    range={range}
                    getBenchmarkOffset={this.getBenchmarkOffset.bind(this)}
                />

              <input
                  id={range['id']}
                  min={range['min_value']}
                  max={range['max_value']}
                  name={`lead-${range['label']}`}
                  step="0.01"
                  defaultValue={isNaN(range['value']) ? range['as_is'] : range['value']}
                  onChange={this.rangeChange}
                  type="range"
                  className={`custom-range ${range['is_decreasing'] ? 'decreasing' : ''}`}
                />
            </div>
          </div>
        </div>))
    );
  }

  render() {
    return (
      <div className="h-100 w-100 overflow-hidden">
        <div className={`container-fluid ranges-container lead-indicators ${this.state.isMounted ? '' : 'unmounting'}`}>
          <ConfigIcon onClick={this.handleInfoClick} id="filter-history-popover" className="config-button navigation-button" />
          <div className="info-popover history-popover" style={this.state["filter-history-popover"] ? {opacity: 1} : {opacity: 0, display: 'none'} } >
            <p>Offering:</p>
            <p className="name">{this.props.activeOffering}</p>
            <p>Sub-Offering:</p>
            <p className="name">{this.props.activeSubOffering}</p>
            <p>Process:</p>
            <p className="name">{this.props.activeProcess}</p>
            <p>Business Region:</p>
            <p className="name">{this.props.activeRegion}</p>
            <button onClick={this.handleResetClick} className="btn reset-btn btn-block">Reset</button>
          </div>
          <HomeIcon onClick={this.handleItemClick} name="basic-configuration" className="home-button navigation-button" />
          <div className="main-header-container">
            <h1 className="main-header">
              <span className="header-border header-border-left"></span>
                Process Maturity Matrix
              <span className="header-border header-border-right"></span>
            </h1>
          </div>
          <div className="pre-content-second-header-container footer pre-content-container">
            <p className="pre-content">
              Basic configuration
            </p>
          </div>
          <div className="pre-content-first-header-container footer pre-content-container">
            <p className="pre-content">
              Business outcome indicators
            </p>
          </div>
          <div className="secondary-header-container">
            <h2 className="secondary-header">
              Lead indicators
            </h2>
          </div>
          <div className="container-fluid h-100 inner-filters-container">
            <div className="container-fluid ranges table">
                <div className="head row">
                  <div className="col-3 first-col"><div>Lead Indicators Name</div></div>
                  <div className="col range"><div>As-is selector</div></div>
                </div>
                <div className="ranges-scroll-container">
                  { this.renderRanges() }
                </div>
            </div>
          </div>
          <div className="next-container">
            <div
              className="prev-button cursor-pointer"
              name="business-outcome-indicators"
              onClick={this.handleItemClick}
            >
              <img className="prev-button-img" src={Prev} alt="prev" />
              <span>Prev</span>
            </div>
            <div
              className="next-button cursor-pointer"
              name="results"
              onClick={this.handleItemClick}
            >
              <img className="next-button-img" src={Next} alt="next" />
              <span>Next</span>
            </div>
            <div className="benchmark-bottom-container">
              <span>Benchmark</span>
              <BenchmarkFlag />
            </div>
            <div
                className="benchmark-bottom-container"
                style={{marginRight: "11%"}}
            >
              <span>To&nbsp;be</span>
              <BenchmarkFlagOrange />
            </div>
          </div>
          <div className="results-footer footer">
            <p>Results</p>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    leadRanges: state.dataSet.activeDataSet.leadRanges,
    activeOffering: state.filter.activeOffering,
    activeSubOffering: state.filter.activeSubOffering,
    activeProcess: state.filter.activeProcess,
    activeRegion: state.filter.activeRegion,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    manipulateLiValue(chartId, value) {
      dispatch(manipulateLiValue(chartId, value));
    },
    checkIfActiveDataSet() {
      dispatch(checkIfActiveDataSet());
    },
    resetAll() {
      dispatch(resetAll());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadIndicators);
